

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { PraticheService } from "src/app/services/pratiche.service";
import { Timestamp } from 'firebase/firestore'; 
import { AppuntamentoFase2 } from "src/app/models/dto/appuntamentoFase2.model";
  

@Component({
    selector: "component-modifica-data_attivazione",
    templateUrl: "./dialog-modifica-data_attivazione.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogModificaDataAttivazione implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected modificaDataAttivazioneForm: FormGroup;
    protected isModificandoDataAttivazione:boolean = false;
    private dataAttivazione:Date;
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
      private messageService: MessageService,
    ) {
      this.pratica            = this.config.data.pratica;
      this.dataAttivazione    = this.pratica.dataAppuntamentoFase2 ? this.convertFirestoreTimestampToDate(this.pratica.dataAppuntamentoFase2): null;
      
      this.logger.info();
      this.modificaDataAttivazioneForm = this.formBuilder.group({
        dataAttivazione:  [ this.dataAttivazione, [Validators.required]]
      });
      
    }
    ngOnInit() {
    }

    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }
   
  
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isModificandoDataAttivazione = true;
        let appuntamento:AppuntamentoFase2 = new AppuntamentoFase2();
        appuntamento.data  = this.modificaDataAttivazioneForm.get('dataAttivazione').value;;
        this.praticheService.modificaDataAttivazioneFase2(this.pratica.id, appuntamento).subscribe( {
          next: (res) => {
            this.isModificandoDataAttivazione = false;
            this.dialogRef.close({ success: true});
          },  error: (e) => {
            this.isModificandoDataAttivazione = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di modifica della data di attivazione della pratica!",
              });
            this.dialogRef.close({ success: false });
          },
          complete: () => {}
          }
        );
       }
    }
  
  }